import { j as a } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const o = e((s, c) => /* @__PURE__ */ a.jsx(
  l,
  {
    ref: c,
    ...s,
    image: (r) => /* @__PURE__ */ a.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...r,
        children: [
          /* @__PURE__ */ a.jsxs(
            "mask",
            {
              id: "mask0_2974_4178",
              width: 32,
              height: 22,
              x: 8,
              y: 13,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: [
                /* @__PURE__ */ a.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M8 13v22h32V13zm30.843 1.179v2.75H22.458v-2.75zM22.458 25.57v-3.044h16.385v3.044zm16.385 1.277v3.045H9.157v-3.045zM22.458 21.25v-3.045h16.385v3.045zM9.157 14.179h12.048V25.57H9.157zm0 19.544v-2.652h29.686v2.652z"
                  }
                ),
                /* @__PURE__ */ a.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M11.759 17.223c.32 0 .578-.264.578-.59a.584.584 0 0 0-.578-.588.584.584 0 0 0-.578.589c0 .325.259.59.578.59M15.229 17.223c.32 0 .578-.264.578-.59a.584.584 0 0 0-.578-.588.584.584 0 0 0-.578.589c0 .325.258.59.578.59M18.699 17.223c.32 0 .578-.264.578-.59a.584.584 0 0 0-.578-.588.584.584 0 0 0-.579.589c0 .325.26.59.579.59M11.759 20.66c.32 0 .578-.263.578-.589a.584.584 0 0 0-.578-.589.584.584 0 0 0-.578.59c0 .325.259.589.578.589M15.229 20.66c.32 0 .578-.263.578-.589a.584.584 0 0 0-.578-.589.584.584 0 0 0-.578.59c0 .325.258.589.578.589M18.699 20.66c.32 0 .578-.263.578-.589a.584.584 0 0 0-.578-.589.584.584 0 0 0-.579.59c0 .325.26.589.579.589M11.759 24.098c.32 0 .578-.264.578-.59a.584.584 0 0 0-.578-.588.584.584 0 0 0-.578.589c0 .325.259.59.578.59M15.229 24.098c.32 0 .578-.264.578-.59a.584.584 0 0 0-.578-.588.584.584 0 0 0-.578.589c0 .325.258.59.578.59M18.699 24.098c.32 0 .578-.264.578-.59a.584.584 0 0 0-.578-.588.584.584 0 0 0-.579.589c0 .325.26.59.579.59"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ a.jsx("g", { mask: "url(#mask0_2974_4178)", children: /* @__PURE__ */ a.jsx("path", { fill: "currentColor", d: "M0-.247h48v48.911H0z" }) })
        ]
      }
    )
  }
));
o.displayName = "AgencyFlagUsaIcon";
export {
  o as AgencyFlagUsaIcon,
  o as default
};
//# sourceMappingURL=index.js.map
